/* eslint-disable no-script-url */

import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import store from '../../store'
import { unsetAuth } from '../../store/actions/auth'
import { useHistory } from 'react-router'
import { makeStyles } from '@material-ui/core/styles'

import {
  Typography,
  AppBar,
  Toolbar,
  IconButton,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Drawer,
  Popover,
  Box,
  Badge
} from '@material-ui/core'
import { ListItemProps } from '@material-ui/core/ListItem'
import {
  Announcement,
  People,
  Event,
  Mail,
  Settings,
  Call,
  Photo,
  Info,
  MenuBook,
  AccountCircle,
  ErrorRounded
} from '@material-ui/icons'
import axios from 'axios'
import clsx from 'clsx'
import { User } from '../../types/User'
import { unsetSearchQueryMessages } from '../../store/actions/searchQueryMessages'

const drawerWidth = 240

const useStyles = makeStyles(theme => ({
  toolbar: {
    paddingRight: 24 // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1
  },
  menuButton: {
    marginRight: 36
  },
  menuButtonHidden: {
    display: 'none'
  },
  title: {
    flexGrow: 1,
    cursor: 'pointer'
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    width: theme.spacing(10)
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column'
  },
  flexCenter: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: 75
  },
  menuText: {
    lineHeight: '1rem'
  },
  badge: {
    '& .MuiBadge-badge': {
      top: '10px',
      right: '1px'
    }
  }
}))

type UserWithMessageInfo = User & { unread: number; user_unread: number; message_count: number }
type MessageUserSearchResponse = {
  number_of_hits: number
  users: UserWithMessageInfo[]
  app_name: string
  unread_total: number
}

const DefaultToolbar: React.FC<
  ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>
> = ({ admin, unsetAuth, unsetSearchQueryMessages }) => {
  const classes = useStyles({})
  const [accountMenuAnchorElm, setAccountMenuAnchorElm] = useState<null | HTMLElement>(null)
  const [unreadMessage, setUnreadMessage] = useState<number>(0)
  const history = useHistory()

  const ListItemLink = (props: ListItemProps<'a', { button?: true }>) => {
    return <ListItem button component="a" {...props} />
  }

  const handleLogout = () => {
    unsetAuth()
  }

  let envText1: string
  let envText2: string
  switch (process.env.REACT_APP_NODE_ENV) {
    case 'local':
      envText1 = process.env.REACT_APP_LOCAL_HEADER_1
      envText2 = process.env.REACT_APP_LOCAL_HEADER_2
      break
    case 'development':
      envText1 = process.env.REACT_APP_DEV_HEADER_1
      envText2 = process.env.REACT_APP_DEV_HEADER_2
      break
    case 'base':
      envText1 = process.env.REACT_APP_BASE_HEADER_1
      envText2 = process.env.REACT_APP_BASE_HEADER_2
      break
    case 'staging':
      envText1 = process.env.REACT_APP_STAGING_HEADER_1
      envText2 = process.env.REACT_APP_STAGING_HEADER_2
      break
    case 'production':
      envText1 = process.env.REACT_APP_PROD_LOGIN_1
      envText2 = process.env.REACT_APP_PROD_LOGIN_2
      break
    case 'test':
      envText1 = process.env.REACT_APP_TEST_LOGIN_1
      envText2 = process.env.REACT_APP_TEST_LOGIN_2
      break
    default:
      envText1 = process.env.REACT_APP_BASE_HEADER_1
      envText2 = process.env.REACT_APP_BASE_HEADER_2
      break
  }

  const drawerItems = [
    {
      href: '/users',
      text: 'ユーザー\n一覧',
      iconComponent: <People />,
      onClick: () => {}
    },
    {
      href: '/messages',
      text: 'ユーザー\nメッセージ',
      iconComponent: <Mail />,
      onClick: () => {
        unsetSearchQueryMessages()
      }
    },
    {
      href: '/',
      text: 'お知らせ\n情報管理',
      iconComponent: <Announcement />,
      onClick: () => {}
    },
    {
      href: '/events',
      text: 'イベント\n情報管理',
      iconComponent: <Event />,
      onClick: () => {}
    },
    {
      href: '/banner',
      text: 'バナー画像',
      iconComponent: <Photo />,
      onClick: () => {}
    },
    // {
    //   href: '/society-info',
    //   text: '学会情報',
    //   iconComponent: <Info />,
    // onClick: () => {}
    // },
    {
      href: '/contact',
      text: 'お問い合わせ\n情報',
      iconComponent: <Call />,
      onClick: () => {}
    },
    {
      href: '/admins',
      text: '設定',
      iconComponent: <Settings />,
      onClick: () => {}
    },
    {
      href: '',
      text: '操作\nマニュアル',
      iconComponent: <MenuBook />,
      onClick: () => window.open('onepas_jspc_manual.pdf', '_blank')
    }
  ]

  const fetchUnreadMessage = async () => {
    const { data } = await axios.get<MessageUserSearchResponse>('/messages/users/search')
    setUnreadMessage(data.unread_total)
  }

  useEffect(() => {
    try {
      fetchUnreadMessage()
    } catch (error) {
      alert(error.message)
    }
  }, [])

  return (
    <React.Fragment>
      {/* ドロワーが開いているか閉まっているかでクラスを差し替え */}
      <AppBar position="absolute" className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          <Typography
            component="h1"
            variant="h6"
            color="inherit"
            noWrap
            className={classes.title}
            onClick={() => history.push('/')}
          >
            {envText1} {envText2}
          </Typography>
          <Box>
            <IconButton
              onClick={(event: React.MouseEvent<HTMLElement>) => {
                setAccountMenuAnchorElm(event.currentTarget)
              }}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
            <Popover
              open={Boolean(accountMenuAnchorElm)}
              anchorEl={accountMenuAnchorElm}
              onClose={() => setAccountMenuAnchorElm(null)}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center'
              }}
            >
              <List component="nav" aria-label="secondary mailbox folders">
                <ListItemLink href="#simple-list">
                  <ListItemText primary={`${admin.name}としてログインしています`} />
                </ListItemLink>
                <Divider />
                <ListItemLink button href={`/edit-admin/${admin.id}`}>
                  <ListItemText primary="管理者情報編集" />
                </ListItemLink>
                <ListItem button onClick={handleLogout}>
                  <ListItemText primary="ログアウト" />
                </ListItem>
              </List>
            </Popover>
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        classes={{
          paper: clsx(classes.drawerPaper, classes.drawerPaperClose)
        }}
      >
        <div className={classes.toolbarIcon} />
        <List disablePadding>
          {drawerItems.map(item => (
            <React.Fragment>
              <ListItemLink
                button
                href={item.href}
                key={item.text}
                onClick={item.onClick}
                className={classes.flexCenter}
              >
                <Badge
                  className={classes.badge}
                  badgeContent={<ErrorRounded color="error" />}
                  invisible={item.href === '/messages' ? unreadMessage <= 0 : true}
                >
                  <ListItemIcon className={classes.flexCenter}>
                    <div>{item.iconComponent}</div>
                    {item.text.split('\n').map(text => (
                      <Typography variant="caption" className={classes.menuText}>
                        {text}
                      </Typography>
                    ))}
                  </ListItemIcon>
                </Badge>
              </ListItemLink>
              <Divider />
            </React.Fragment>
          ))}
        </List>
      </Drawer>
    </React.Fragment>
  )
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    unsetAuth: () => dispatch(unsetAuth()),
    unsetSearchQueryMessages: () => dispatch(unsetSearchQueryMessages())
  }
}

const mapStateToProps = (state: ReturnType<typeof store.getState>) => {
  // 上のApp変数のpropsに下のreturn
  // で返ってくるオブジェクトが入る
  return {
    admin: state.auth
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultToolbar)
